import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  factoresCriticidad: null,
  factoresCriticidadError: "",
  formError: "",
};

export default function FactoresCriticidadReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_FACTORES_CRITICIDAD:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_FACTORES_CRITICIDAD:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FACTORES_CRITICIDAD:
      return { ...state, factoresCriticidad: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FACTORES_CRITICIDAD_FAIL:
      return { ...state, factoresCriticidadError: action.payload };
    default:
      return state;
  }
}
